import PageTab from './index.vue';

export default PageTab as any;
